import { styled } from 'styled-components';

import { bodySmallText, colors, cssBreakpoints, spacing } from '#/theme/theme';

export const LargeFilePickerFilenameBody = styled.div`
  display: flex;
  gap: ${spacing[8]};

  > * {
    /* Make link and remove button position relative so they capture click in place of the input */
    position: relative;
  }
`;

export const LargeFilePickerFilenameLink = styled.a`
  color: ${colors.mediumContentGrey};
`;

export const LargeFilePickerFilenameText = styled.div`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  vertical-align: middle;
  max-width: 300px;

  @media all and (min-width: ${cssBreakpoints.xsUp}) {
    max-width: none;
    overflow: visible;
    white-space: normal;
    text-overflow: clip;
  }
`;

export const LargeFilePickerFilenameLastUpdated = styled.p`
  ${bodySmallText};
  margin: 0;
  color: ${colors.lightContentGrey};
  white-space: nowrap;
`;
